/**
 * Characters a set code is drawn from, chosen so none can be mistaken for another
 * when handwritten or projected. Must match `public.generate_question_set_code`
 * and the `question_sets_code_check` constraint.
 */
export const QUESTION_SET_CODE_ALPHABET = 'ACEFHJKMNPRTUWXY23456789';
export const QUESTION_SET_CODE_LENGTH = 6;
export const QUESTION_SET_CODE_PATTERN = new RegExp(
  `^[${QUESTION_SET_CODE_ALPHABET}]{${QUESTION_SET_CODE_LENGTH}}$`
);

/** Matches the number of rows on the answer sheet. */
export const QUESTION_SET_MAX_COUNT = 10;

/** The maximum and default number of sets a listing returns. */
export const QUESTION_SET_QUERY_LIMIT = 200;

export const QUESTION_SET_MAX_TOPICS = 200;
export const QUESTION_SET_MAX_TOPIC_GROUPS = 50;
export const QUESTION_SET_MAX_QUESTION_TYPES = 20;
export const QUESTION_SET_MAX_DIRECTIVE_VERBS = 50;
export const QUESTION_SET_MAX_SOURCE_SETS = 20;
export const QUESTION_SET_MAX_DIFFICULTY_RANGES = 10;

/** The most students a draw leaves out the questions of; a class holds far fewer. */
export const QUESTION_SET_MAX_SEEN_BY = 200;

export const QUESTION_SET_BLUEPRINT_VERSION = 1;

/** The most units a page of a set's replacement candidates holds. */
export const QUESTION_SET_CANDIDATES_MAX_LIMIT = 50;

/**
 * The only fields `update` edits. Status and the publish stamps change through
 * `publish`; the rest is fixed when the set is composed.
 */
const updateAttributes = ['title', 'description'] as const;

export const QuestionSetAttributes = {
  Update: updateAttributes,
};
